/**
 * Three-state newsletter status (handover §5, PO Q6-A). Rollup across the group; upgraded
 * to `SubscribedSuppressed` when any suppression exists on the address.
 */
export enum NewsletterStatus {
  NotSubscribed = 0,
  Subscribed = 1,
  SubscribedSuppressed = 2,
}
